module.exports = __webpack_public_path__ + "img/64.f2c7d8b0.jpg";